import { IProductPagination } from "src/models";
import * as Types from "src/redux/types";

type State = {
  pageData: {};
  totalItems: number;
  totalPages: number;
  currentPage: number;
  hasNextPage: boolean;
  hasPrevPage: boolean;
  nextPage: number | null;
  prevPage: number | null;
  pageSize: number;
};

const initialState: State = {
  pageData: {},
  totalItems: 0,
  totalPages: 0,
  currentPage: 1,
  hasNextPage: true,
  hasPrevPage: false,
  nextPage: 2,
  prevPage: null,
  pageSize: 15,
};

const ProductPaginationReducer = (
  state = initialState,
  action: Action<IProductPagination | number>
): State => {
  const { type, payload } = action;
  switch (type) {
    case Types.PRODUCT_PAGE_LOAD: {
      const data = payload as IProductPagination;
      const {
        totalItems,
        totalPages,
        currentPage,
        hasNextPage,
        hasPrevPage,
        nextPage,
        prevPage,
        pageSize,
      } = data;
      return {
        ...state,
        totalItems,
        totalPages,
        currentPage,
        hasNextPage,
        hasPrevPage,
        nextPage,
        prevPage,
        pageSize,
        pageData: {
          ...state.pageData,
          [data.currentPage]: [...data.products],
        },
      };
    }

    default:
      return state;
  }
};

export default ProductPaginationReducer;
